(function() {
    function iniciarSlider() {
        const slider = document.querySelector('.header__slider');

        if (slider && typeof Swiper !== 'undefined') {
            new Swiper('.header__slider', {
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 20000,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', iniciarSlider);
})();